import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AdminAuthProvider } from '../admin/auth/AdminAuthContext';
import SeoRouteManager from './Parts/SeoRouteManager';

const Home1 = lazy(() => import('./Pages/Home1'));
const Home3 = lazy(() => import('./Pages/Home3'));
const Home4 = lazy(() => import('./Pages/Home4'));
const Home5 = lazy(() => import('./Pages/Home5'));
const Home6 = lazy(() => import('./Pages/Home6'));
const Home7 = lazy(() => import('./Pages/Home7'));
const Home8 = lazy(() => import('./Pages/Home8'));
const Home9 = lazy(() => import('./Pages/Home9'));
const Home10 = lazy(() => import('./Pages/Home10'));
const Home11 = lazy(() => import('./Pages/Home11'));
const Home12 = lazy(() => import('./Pages/Home12'));
const About1 = lazy(() => import('./Pages/About1'));
const About2 = lazy(() => import('./Pages/About2'));
const Services1 = lazy(() => import('./Pages/Services1'));
const Services2 = lazy(() => import('./Pages/Services2'));
const ServicesAgricultural = lazy(() => import('./Pages/ServicesAgricultural'));
const ServicesCivil = lazy(() => import('./Pages/ServicesCivil'));
const ServicesChemical = lazy(() => import('./Pages/ServicesChemical'));
const ServicesMep = lazy(() => import('./Pages/ServicesMep'));
const ServicesMechanical = lazy(() => import('./Pages/ServicesMechanical'));
const ServicesOilgas = lazy(() => import('./Pages/ServicesOilgas'));
const ServicesPowerEnergy = lazy(() => import('./Pages/ServicesPowerEnergy'));
const ProjectMasonry = lazy(() => import('./Pages/ProjectMasonry'));
const ProjectCarousel = lazy(() => import('./Pages/ProjectCarousel'));
const ProjectDetail = lazy(() => import('./Pages/ProjectDetail'));
const ProjectsShowcase = lazy(() => import('./Pages/ProjectsShowcase'));
const Shop = lazy(() => import('./Pages/Shop'));
const ShopDetail = lazy(() => import('./Pages/ShopDetail'));
const ShoppingCart = lazy(() => import('./Pages/ShoppingCart'));
const Checkout = lazy(() => import('./Pages/Checkout'));
const Wishlist = lazy(() => import('./Pages/Wishlist'));
const BlogGrid = lazy(() => import('./Pages/BlogGrid'));
const BlogList = lazy(() => import('./Pages/BlogList'));
const BlogPost = lazy(() => import('./Pages/BlogPost'));
const BlogPage = lazy(() => import('./Pages/BlogPage'));
const PricingPlan = lazy(() => import('./Pages/PricingPlan'));
const IconFont = lazy(() => import('./Pages/IconFont'));
const Team = lazy(() => import('./Pages/Team'));
const TeamSingle = lazy(() => import('./Pages/TeamSingle'));
const Faq = lazy(() => import('./Pages/Faq'));
const Error403 = lazy(() => import('./Pages/Error403'));
const Error404 = lazy(() => import('./Pages/Error404'));
const Error405 = lazy(() => import('./Pages/Error405'));
const ContactUs = lazy(() => import('./Pages/ContactUs'));
const Fitouts = lazy(() => import('./Pages/Fitouts'));
const EngineeringSurvey = lazy(() => import('./Pages/EngineeringSurvey'));
const Tos = lazy(() => import('./Pages/Tos'));
const ServicesTest = lazy(() => import('./Pages/ServicesTest'));
const ServicesEpcTest = lazy(() => import('./Pages/ServicesEpcTest'));
const RequireAdminAuth = lazy(() => import('../admin/components/RequireAdminAuth'));
const AdminLayout = lazy(() => import('../admin/components/AdminLayout'));
const AdminLogin = lazy(() => import('../admin/pages/AdminLogin'));
const AdminDashboard = lazy(() => import('../admin/pages/AdminDashboard'));
const AdminProjectsPage = lazy(() => import('../admin/pages/AdminProjectsPage'));
const AdminVideosPage = lazy(() => import('../admin/pages/AdminVideosPage'));
const AdminContentPage = lazy(() => import('../admin/pages/AdminContentPage'));
const AdminUsersPage = lazy(() => import('../admin/pages/AdminUsersPage'));
const AdminHomepagePage = lazy(() => import('../admin/pages/AdminHomepagePage'));

function Components() {
    return (
        <BrowserRouter basename="/">
            <SeoRouteManager />
            <AdminAuthProvider>
                <div className="page-wraper">
                    <Suspense fallback={null}>
                        <Routes>
                            <Route path='/admin/login' element={<AdminLogin />} />

                            <Route element={<RequireAdminAuth allowedRoles={['admin', 'editor', 'viewer']} />}>
                                <Route path='/admin' element={<AdminLayout />}>
                                    <Route index element={<AdminDashboard />} />

                                    <Route element={<RequireAdminAuth allowedRoles={['admin', 'editor']} />}>
                                        <Route path='homepage' element={<AdminHomepagePage />} />
                                        <Route path='projects' element={<AdminProjectsPage />} />
                                        <Route path='videos' element={<AdminVideosPage />} />
                                        <Route path='content' element={<AdminContentPage />} />
                                        <Route
                                            path='content/about-us'
                                            element={
                                                <AdminContentPage
                                                    initialPageId='about_us'
                                                    lockPageSelection
                                                    pageTitle='About Us Content'
                                                />
                                            }
                                        />
                                        <Route
                                            path='content/what-we-do'
                                            element={
                                                <AdminContentPage
                                                    initialPageId='what_we_do'
                                                    lockPageSelection
                                                    pageTitle='What We Do Content'
                                                />
                                            }
                                        />
                                        <Route
                                            path='content/common-concerns'
                                            element={
                                                <AdminContentPage
                                                    initialPageId='faq'
                                                    lockPageSelection
                                                    pageTitle='Common Concerns Content'
                                                />
                                            }
                                        />
                                        <Route
                                            path='content/contact-us'
                                            element={
                                                <AdminContentPage
                                                    initialPageId='contactus'
                                                    lockPageSelection
                                                    pageTitle='Contact Us Content'
                                                />
                                            }
                                        />
                                    </Route>

                                    <Route element={<RequireAdminAuth allowedRoles={['admin']} />}>
                                        <Route path='users' element={<AdminUsersPage />} />
                                    </Route>
                                </Route>
                            </Route>

                            <Route path='/terms&conditions' exact element={<Tos />} />
                            <Route path='/terms' exact element={<Tos />} />
                            <Route path='/' exact element={<Home1 />} />
                            <Route path='/home-construction3' act element={<Home3/>} />
                            <Route path='/home-transport' act element={<Home4/>} />
                            <Route path='/home-agriculture' act element={<Home5/>} />
                            <Route path='/home-solar-energy' act element={<Home6/>} />
                            <Route path='/home-oilgas-plant' act element={<Home7/>} />
                            <Route path='/home-page8' act element={<Home8/>} />
                            <Route path='/home-industries9' act element={<Home9/>} />
                            <Route path='/home-factory10' act element={<Home10/>} />
                            <Route path='/home-construction11' act element={<Home11/>} />
                            <Route path='/home-conditioning-repair12' act element={<Home12/>} />

                            <Route path='/about_us' element={<About1/>} />
                            <Route path='/about' element={<About1/>} />
                            <Route path='/about-2' act element={<About2/>} />

                            <Route path='/services-1' act element={<Services1/>} />
                            <Route path='/services-2' act element={<Services2/>} />
                            <Route path='/services-heavy-equipment' act element={<ServicesAgricultural/>} />
                            <Route path='/services-mep' act element={<ServicesMep/>} />
                            <Route path='/services-infrastructure' act element={<ServicesChemical/>} />
                            <Route path='/services-civil' act element={<ServicesCivil/>} />
                            <Route path='/services-steel-structure' act element={<ServicesMechanical/>} />
                            <Route path='/what_we_do' act element={<ServicesOilgas/>} />
                            <Route path='/services-epc' act element={<ServicesOilgas/>} />
                            <Route path='/services-civil-defense' act element={<ServicesPowerEnergy/>} />
                            <Route path='/services-fitout' act element={<Fitouts/>} />
                            <Route path='/services-Survey' act element={<EngineeringSurvey/>} />
                            <Route path='/services-test' element={<ServicesTest/>} />
                            <Route path='/services-epc-test' element={<ServicesEpcTest/>} />


                            <Route path='/projects' act element={<ProjectsShowcase/>} />
                            <Route path='/projects-showcase' element={<ProjectsShowcase/>} />
                            <Route path='/project-masonry' act element={<ProjectMasonry/>} />
                            <Route path='/project-carousel' act element={<ProjectCarousel/>} />
                            <Route path='/project-detail' act element={<ProjectDetail/>} />

                            <Route path='/shop' act element={<Shop/>} />
                            <Route path='/shop-detail' act element={<ShopDetail/>} />
                            <Route path='/shopping-cart' act element={<ShoppingCart/>} />
                            <Route path='/checkout' act element={<Checkout/>} />
                            <Route path='/wishlist' act element={<Wishlist/>} />

                            <Route path='/blog-grid' act element={<BlogGrid/>} />
                            <Route path='/blog-list' act element={<BlogList/>} />
                            <Route path='/blog-post' act element={<BlogPost/>} />
                            <Route path='/blog' element={<BlogPage/>} />

                            <Route path='/pricing-plan' act element={<PricingPlan/>} />
                            <Route path='/icon-font' act element={<IconFont/>} />
                            <Route path='/team' act element={<Team/>} />
                            <Route path='/team-single' act element={<TeamSingle/>} />
                            <Route path='/faq' act element={<Faq/>} />
                            <Route path='/error403' act element={<Error403/>} />
                            <Route path='/error404' act element={<Error404/>} />
                            <Route path='/error405' act element={<Error405/>} />

                            <Route path='/contactus' act element={<ContactUs/>} />


                            <Route element={Error} />
                        </Routes>
                    </Suspense>
                </div>
            </AdminAuthProvider>
        </BrowserRouter>
    );
}

export default Components;
